<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Transactions"
              bc1="App"
              bc2="Transactions"
              bc3="Details"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$emit('backFromDetailPage')"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <section v-if="!isEmpty(transactionDetails)" class="invoice-preview-wrapper">
          <div class="row invoice-preview">
            <!-- Invoice -->
            <div class="col-12">
              <div class="card invoice-preview-card">
                <div class="card-body invoice-padding pb-0">
                  <!-- Header starts -->
                  <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
                    <div>
                      <div class="logo-wrapper">
                        <h3><img width="150" :src="`${publicPath}vaults-authlogo.png`"></h3>
                      </div>
                      <p class="card-text mb-25">Payment Method: {{ transactionDetails.payment_method?transactionDetails.payment_method.name:'N/A' }}</p>
                      <p class="card-text mb-25">Gateway Ref Id:
                        {{ transactionDetails.gateway_reference_id ? transactionDetails.gateway_reference_id : 'N/A' }}</p>
                      <p class="card-text mb-25">Ref Id:
                        {{ transactionDetails.reference_id ? transactionDetails.reference_id : 'N/A' }}</p>
                      <p class="card-text mb-0">Transaction Type: {{ transactionDetails.transaction_type? transactionDetails.transaction_type.name:'N/A' }}</p>
                      <p class="card-text mb-0" v-if="transactionDetails.settlement_status == 1">Settlement Status:  <span class="badge badge-pill mt-1  badge-glow badge-info">INITIATED</span></p>
                      <p class="card-text mb-0" v-else-if="transactionDetails.settlement_status == 2">Settlement Status: <span class="badge badge-pill mt-1  badge-glow badge-danger">CANCELED</span></p>
                      <p class="card-text mb-0" v-else-if="transactionDetails.settlement_status == 3">Settlement Status:  <span class="badge badge-pill mt-1  badge-glow badge-success">DONE</span></p>
                      <p class="card-text mb-0" v-else>Settlement Status:  <span class="badge badge-pill mt-1  badge-glow badge-warning">PENDING</span></p>

                      <p class="card-text mb-25" v-if="transactionDetails.status == 1">Transaction Status:  <span class="badge  mt-1  badge-glow badge-info">Success</span></p>
                      <p class="card-text mb-25" v-else-if="transactionDetails.status == 2">Transaction Status: <span class="badge  mt-1  badge-glow badge-danger">Failed</span></p>
                      <p class="card-text mb-25" v-else> Transaction Status:  <span class="badge  mt-1  badge-glow badge-warning">PENDING</span></p>
                      <p class="card-text mb-25 mt-1">Aquiring: {{ transactionDetails.aquiring?transactionDetails.aquiring.name+'/'+transactionDetails.aquiring.code:'N/A' }}</p>
                      <p class="card-text mb-25 mt-1">Schema: {{ transactionDetails.schema?transactionDetails.schema.name+'/'+transactionDetails.schema.code:'N/A' }}</p>
                      <p class="card-text mb-25 mt-1">Channel: {{ transactionDetails.channel?transactionDetails.channel.name+'/'+transactionDetails.channel.code:'N/A' }}</p>
                      <p class="card-text mb-25 mt-1">Store: {{ transactionDetails.store?transactionDetails.store.name:'N/A' }}</p>
                      <p class="card-text mb-25 mt-1">Country: {{ transactionDetails.country_code?transactionDetails.country_code:'N/A' }}</p>
                      <p class="card-text mb-25 mt-1">Approval Code: {{ transactionDetails.approval_code?transactionDetails.approval_code:'N/A' }}</p>
                    </div>
                    <div class="mt-md-0 mt-2">
                      <h4 class="invoice-title">
                        Transaction
                        <span class="invoice-number">#{{ transactionDetails.uuid }}</span>
                      </h4>
                      <div class="invoice-date-wrapper justify-content-end">
                        <p class="invoice-date-title">Date Created:</p>
                        <p class="invoice-date">{{
                                customFormatDateTime(transactionDetails.created_at)
                          }}</p>
                      </div>
                    </div>
                  </div>
                  <!-- Header ends -->
                </div>

                <hr class="invoice-spacing"/>

                <!-- Address and Contact starts -->
                <div class="card-body invoice-padding pt-0">
                  <div class="row invoice-spacing">
                    <div class="col-xl-8 p-0">
                      <h6 class="mb-2">Sender Details:</h6>
                      <h6 class="mb-25">Name: {{transactionDetails.sender.first_name + ' '+ transactionDetails.sender.last_name }}</h6>
                      <p class="card-text mb-25">Email: {{transactionDetails.sender.email}} </p>
                      <p class="card-text mb-25">Account title: {{transactionDetails.sender_account_title}}</p>
                      <p class="card-text mb-25">Account Number: {{transactionDetails.sender_account_number}}</p>
                      <p class="card-text mb-25">Customer Email: {{transactionDetails.customer?transactionDetails.customer.email:'N/A'}}</p>
                      <p class="card-text mb-25">Customer Name: {{transactionDetails.customer?transactionDetails.customer.name:'N/A'}}</p>
                      <p class="card-text mb-25">Customer Phone: {{transactionDetails.customer?transactionDetails.customer.phone:'N/A'}}</p>
                    </div>
                    <div class="col-xl-4 p-0 mt-xl-0 mt-2">
                      <h6 class="mb-2">Receiver Details:</h6>
                      <h6 class="mb-25">Name: {{transactionDetails.receiver.first_name + ' '+ transactionDetails.receiver.last_name }}</h6>
                      <p class="card-text mb-25">Email: {{transactionDetails.receiver.email}} </p>
                      <p class="card-text mb-25">Account title: {{transactionDetails.receiver_account_title}}</p>
                      <p class="card-text mb-25">Account Number: {{transactionDetails.receiver_account_number}}</p>
                    </div>
                  </div>
                </div>


                <div class="card-body invoice-padding pb-0 mt-5">
                  <div class="row invoice-sales-total-wrapper">
                    <div class="col-md-4 order-md-1 order-2 mt-md-0 mt-3">

                    </div>
                    <div class="col-md-8 d-flex justify-content-end order-md-2 order-1">
                      <div class="invoice-total-wrapper">
                        <div class="invoice-total-item">
                          <p class="invoice-total-title">Actual Amount:</p>
                          <p class="invoice-total-amount" v-if="transactionDetails.amount != transactionDetails.total_amount">{{ parseFloat(transactionDetails.total_amount / 100).toFixed(amountDecimalPlaces) + ' ' + transactionDetails.currency.code  }}</p>
                          <p class="invoice-total-amount" v-else>{{ parseFloat(transactionDetails.amount / 100).toFixed(amountDecimalPlaces) + ' ' + transactionDetails.currency.code  }}</p>
                        </div>
                        <div class="invoice-total-item">
                          <p class="invoice-total-title">Vat:</p>
                          <p class="invoice-total-amount">
                            {{ parseFloat(transactionDetails.vat / 100).toFixed(feesDecimalPlaces) + ' ' + transactionDetails.currency.code  }}</p>
                        </div>
                        <div class="invoice-total-item">
                          <p class="invoice-total-title">Fee:</p>
                          <p class="invoice-total-amount">
                            {{ parseFloat(transactionDetails.fee / 100).toFixed(feesDecimalPlaces)+ ' ' + transactionDetails.currency.code  }}</p>
                        </div>
                        <hr class="my-50"/>
                        <div class="invoice-total-item">
                          <p class="invoice-total-title">Payable Amount:</p>
                          <p class="invoice-total-amount text-danger" v-if="transactionDetails.transaction_type_id == 6">- {{parseFloat((parseFloat(transactionDetails.amount)+parseFloat(transactionDetails.vat)+parseFloat(transactionDetails.fee))/100).toFixed(amountDecimalPlaces) + ' ' + transactionDetails.currency.code }}</p>
                          <p class="invoice-total-amount" v-else-if="transactionDetails.amount != transactionDetails.total_amount">{{ parseFloat((transactionDetails.amount) / 100).toFixed(amountDecimalPlaces) + ' ' + transactionDetails.currency.code  }}</p>
                          <p class="invoice-total-amount" v-else>{{ parseFloat((transactionDetails.amount - transactionDetails.vat - transactionDetails.fee) / 100).toFixed(amountDecimalPlaces) + ' ' + transactionDetails.currency.code  }}</p>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Invoice Description ends -->

                <hr class="invoice-spacing"/>

                <!-- Invoice Note starts -->
<!--                <div class="card-body invoice-padding pt-0">-->
<!--                  <div class="row">-->
<!--                    <div class="col-12">-->
<!--                      <span class="font-weight-bold">Note:</span>-->
<!--                      <span>It was a pleasure working with you and your team. We hope you will keep us in mind. Thank You!</span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
                <!-- Invoice Note ends -->
              </div>
            </div>
            <!-- /Invoice -->

          </div>
        </section>


      </div>
    </div>
  </div>
</template>

<script>

export default {
  props:['rowData'],
  mounted() {
    this.transactionDetails = this.rowData
  },
  data() {
    return {
      transactionDetails: []

    }
  },
  methods: {},
  watch:{
    rowData(val){
      this.transactionDetails = val
    }
  }

}
</script>
<style>
.table-scroll-y {
  display: block;
  overflow-x: auto;
  white-space: nowrap;
}
</style>

